import * as React from 'react';
import { SpsContactForm } from '../SpsContactForm';
import { useGrowlers } from '@spscommerce/ds-react';



export default function SpsSupportCenter(props) {
  // const [growlers, createGrowler] = useGrowlers();
  return (
    <>
      <SpsContactForm icon={
      <i className="fa fa-life-ring"></i>
    } />
    </>
    
  );
}
